import { ErrorHandler, NgModule } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {
  DateAdapter,
  ErrorStateMatcher,
  ShowOnDirtyErrorStateMatcher,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@env';
import { AiChatLauncherComponent, DOTLOTTIE_LOADER } from '@qtek/libs/ai-chat';
import { HideLoaderGuard, QtDateAdapter } from '@qtek/libs/app-component';
import { KeyboardModule } from '@qtek/libs/keyboard';
import { LayoutModule } from '@qtek/libs/layout';
import {
  PermissionBadgeDirective,
  PermissionDirective,
} from '@qtek/libs/permissions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChunkLoadErrorHandler } from './chunk-load-error-handler';
import {
  CoreModule,
  HTTP_BASE_URL_VALUE,
  TASK_SERVER_BASE_URL_VALUE,
} from './core/core.module';
import { buildSwScriptUrl } from './core/sw-script-url';
import { DealRouteReuseStrategy } from './deal-route-reuse.strategy';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    LayoutModule,
    MatSnackBarModule,
    KeyboardModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatSelectModule,
    ServiceWorkerModule.register(
      // Our backend base URLs (build env or runtime-config.js) tell the SW
      // which requests to remap to SW_NETWORK_ERROR_STATUS on network failure.
      buildSwScriptUrl('custom-sw.js', [
        HTTP_BASE_URL_VALUE,
        TASK_SERVER_BASE_URL_VALUE,
      ]),
      // buildSwScriptUrl('custom-sw.js', ['https://api-js.mixpanel.com']),
      {
        enabled: environment.production,
        registrationStrategy: 'registerImmediately',
        // `ngsw-worker.js` is now imported by `custom-sw.js` rather than being
        // the registered script itself — the default `updateViaCache: 'imports'`
        // would serve it from the HTTP cache and could go stale after an
        // @angular/service-worker upgrade.
        updateViaCache: 'none',
      }
    ),
    PermissionDirective,
    PermissionBadgeDirective,
    AiChatLauncherComponent,
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    // Ensure you are importing and providing the correct state and effects
    HideLoaderGuard,
    { provide: DateAdapter, useExisting: QtDateAdapter },
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        showDelay: 500,
        hideDelay: 0,
        touchendHideDelay: 1500,
      },
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 2000,
      },
    },
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    { provide: RouteReuseStrategy, useClass: DealRouteReuseStrategy },
    {
      provide: DOTLOTTIE_LOADER,
      useValue: () => import('@lottiefiles/dotlottie-web'),
    },
  ],
})
export class AppModule {}
